import React from 'react';

export const ArrowRight = () => <>&nbsp;&#8594;&nbsp;</>;
